exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav__next-button__1jjJF,.nav__prev-button__3nw53{position:absolute;z-index:126;top:50%;border-radius:0;transition:opacity .2s,visibility .2s;opacity:1;padding:10px;width:38px;height:50px;margin-top:-25px}.nav__next-button__1jjJF>svg,.nav__prev-button__3nw53>svg{fill:#fff}.nav__next-button__1jjJF:active,.nav__next-button__1jjJF:focus,.nav__next-button__1jjJF:hover,.nav__prev-button__3nw53:active,.nav__prev-button__3nw53:focus,.nav__prev-button__3nw53:hover{opacity:.7}.nav__prev-button__3nw53{transform:scaleX(-1);filter:FlipH;-ms-filter:\"FlipH\";left:0}.nav__next-button__1jjJF{right:0}", ""]);

// exports
exports.locals = {
	"next-button": "nav__next-button__1jjJF",
	"nextButton": "nav__next-button__1jjJF",
	"prev-button": "nav__prev-button__3nw53",
	"prevButton": "nav__prev-button__3nw53"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/nav/nav.styl
// module id = 2915
// module chunks = 1